module.exports = __webpack_public_path__ + "static/media/spotify.fc0a319a.svg";